var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "84 14 532 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 14c-146.72 0-266 119.28-266 266s119.28 266 266 266 266-119.28 266-266-119.28-266-266-266zm0 499.52c-128.8 0-233.52-104.72-233.52-233.52s104.72-233.52 233.52-233.52 233.52 104.72 233.52 233.52-104.72 233.52-233.52 233.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.2 196-157.36 157.36-80.078-80.078c-7.8398-7.8398-20.719-7.8398-28.559 0s-7.8398 20.719 0 28.559l94.078 94.078c3.9219 3.9219 8.9609 6.1602 14.559 6.1602 5.6016 0 10.641-2.2383 14.559-6.1602l171.36-171.36c7.8398-7.8398 7.8398-20.719 0-28.559-7.8359-7.8398-20.156-7.8398-28.559 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.c931907bf245d2ac2f48b896108156d4.svg";
export { ForwardRef as ReactComponent };